var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M5 20a1 1 0 0 1 2 0c0 7.18 5.82 13 13 13s13-5.82 13-13S27.18 7 20 7a1 1 0 0 1 0-2c8.284 0 15 6.716 15 15s-6.716 15-15 15S5 28.284 5 20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14M8 4v5h2V4zm0 7v2h2v-2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 19,
  y: 10,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 7,
  x: 20.997,
  y: 17.005,
  rx: 1,
  transform: "rotate(127 21.997 20.505)"
}))));
export default SvgDelay;